import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/src/locale/pt.ts";

//customIcons
import Norte from "@/customIcons/Norte.vue";
import Leste from "@/customIcons/Leste.vue";
import CentroSul from "@/customIcons/CentroSul.vue";
import Noroeste from "@/customIcons/Noroeste.vue";
import Oeste from "@/customIcons/Oeste.vue";
import OnlineIcon from "@/customIcons/Online.vue";
import TemperatureMin from "@/customIcons/TemperatureMin.vue";
import TemperatureMax from "@/customIcons/TemperatureMax.vue";
import Export from "@/customIcons/Export.vue"
import NorteOverview from "@/customIcons/NorteOverview.vue";
import LesteOverview from "@/customIcons/LesteOverview.vue";
import CentroSulOverview from "@/customIcons/CentroSulOverview.vue";
import NoroesteOverview from "@/customIcons/NoroesteOverview.vue";
import OesteOverview from "@/customIcons/OesteOverview.vue";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    dark: true,
    themes: {
      light: {
        primary: "#0157BD",
      },
      dark: {
        background: {
          base: "#1B1F2D",
          darken1: "#191C29",
          darken2: "#151723",
        },
        primary: {
          base: "#E8F4F9",
          darken1: "#C7D1D7",
          darken2: "#B0C0C7",
          darken3: "#263238",
        },
        secondary: {
          lighten3: "#384150",
          lighten2: "#191C29",
          lighten1: "#1B1F2D",
          base: "#151723",
        },
        accent: {
          lighten1: "#F99741",
          base: "#F5821E",
          darken1: "#E0AA0F",
          lighten2: "#FFC089",
        },
        error: {
          lighten1: "#FFE1DE",
          base: "#E74C3C",
          darken1: "#B71C1C",
        },
        warning: {
          lighten2: "#FFF9DF",
          lighten1: "#FFEFE1",
          base: "#E67E22",
          darken1: "#E65100",
        },
        success: {
          lighten1: "#EFFFDC",
          base: "#8BC34A",
          darken1: "#33691E",
          darken2: "#1B5E20",
        },
        info: {
          lighten1: "#E8F4F9",
          base: "#E0AA0F",
          darken1: "#263238",
        },

        favorite: "#F2CC0C",

        //Weather alert colors
        alertT9_T10: "#5C0002",
        alertT7_T8: "#D40D12",
        alertT5_T6: "#FF9F00",
        alertT3_T4: "#FDE047",
        alertT1_T2: "#CDDC39",
        alertT0: "#DCE775",

        //Validity alert side menu color
        highlight80: "#B980D0",
        highlight100: "#9B59B6",

        //Shutdown alert colors
        veryHighAlert: "#4C438F",
        highAlert: "#8765D4",
        mediumAlert: "#2B9DA3",
        lowAlert: "#5DD2D8",
        nullAlert: "#9E9E9E",

        //Shutdown alert colorsCircles
        veryHighAlertCircle: "#3F3B70",
        highAlertCircle: "#66519E",
        mediumAlertCircle: "#29777E",
        lowAlertCircle: "#4A9AA1",
        nullAlertCircle: "#75777A",
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    values: {
      onlineIcon: {
        component: OnlineIcon,
      },
      norte: {
        component: Norte,
      },
      leste: {
        component: Leste,
      },
      centroSul: {
        component: CentroSul,
      },
      noroeste: {
        component: Noroeste,
      },
      oeste: {
        component: Oeste,
      },
      temperatureMin: {
        component: TemperatureMin,
      },
      temperatureMax: {
        component: TemperatureMax,
      },
      export: {
        component: Export,
      },
      norteOverview: {
        component: NorteOverview,
      },
      lesteOverview: {
        component: LesteOverview,
      },
      centroSulOverview: {
        component: CentroSulOverview,
      },
      noroesteOverview: {
        component: NoroesteOverview,
      },
      oesteOverview: {
        component: OesteOverview,
      },
      
    },
  },
});
